//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import {
  Form,
  FormItem,
  Input,
  Scrollbar,
  Radio,
  RadioGroup,
  Cascader,
  Select,
  Option,
} from 'element-ui';
import {
  checkMobileMetaV2,
  checkMobileMetaHK,
  realNameAuthentication,
} from '@/api/member';
import { replaceToHidden } from '@/utils/util';
import GRadio from '@/components/public/radio.vue';
import MessageDialog from '@/components/public/violation/message-dialog.vue';
export default {
  components: {
    ElScrollbar: Scrollbar,
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    GRadio,
    ElRadio: Radio,
    ElRadioGroup: RadioGroup,
    ElCascader: Cascader,
    ElSelect: Select,
    ElOption: Option,
    MessageDialog,
  },
  data() {
    return {
      showNoRequired: true,
      pcaTextArr: [],
      messageData: {
        show: false, // 是否显示温馨提示
        content: '', // 温馨提示内容
      },
      form: {
        realName: null,
        identityType: 'IDENTITY_CARD',
        otherIdentityType: null,
        idNumber: null,
        agree: false,
        highestEducation: null,
        career: null,
        location: [],
        address: null,
        telephone: null,
        postcode: null,
        sincerityRecord: null,
        company: null,
        position: null,
        email: null,
      },
      rules: {
        realName: [
          {
            required: true,
            trigger: 'blur',
            validator(_rule, val, callback) {
              if (!val || (/^[\u4E00-\u9FA5]+$/.test(val) && val.length < 2)) {
                callback('请输入您的真实姓名');
              }
              callback();
            },
          },
        ],
        code: [
          {
            required: true,
            trigger: 'blur',
            validator: (_rule, val, callback) => {
              if (
                this.form.identityType === 'OTHER' &&
                !this.form.otherIdentityType
              ) {
                callback('填写证件类型名称');
              } else if (!this.form.idNumber) {
                callback('请输入您的证件号码');
              }
              callback();
            },
          },
        ],
        location: [
          {
            required: true,
            trigger: 'change',
            message: '请选择省、市、区、街道',
          },
        ],
        highestEducation: [
          {
            required: true,
            trigger: 'change',
            message: '请选择最高学历',
          },
        ],
        career: [
          {
            required: true,
            trigger: 'change',
            message: '请选择职业',
          },
        ],
        address: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入详细地址',
          },
        ],
      },
      select: {
        identityType: [
          {
            value: 'IDENTITY_CARD',
            label: '身份证',
          },
          {
            value: 'RESIDENCE_PERMIT',
            label: '港澳台居住证',
          },
          {
            value: 'OTHER',
            label: '其他',
          },
        ],
        highestEducation: [
          {
            value: '博士',
            label: '博士',
          },
          {
            value: '硕士',
            label: '硕士',
          },
          {
            value: '本科',
            label: '本科',
          },
          {
            value: '大专',
            label: '大专',
          },
          {
            value: '中专',
            label: '中专',
          },
          {
            value: '高中',
            label: '高中',
          },
          {
            value: '初中及以下',
            label: '初中及以下',
          },
        ],
        career: [
          {
            value: '党政机关工作人员',
            label: '党政机关工作人员',
          },
          {
            value: '企事业单位职工',
            label: '企事业单位职工',
          },
          {
            value: '农民',
            label: '农民',
          },
          {
            value: '证券从业人员',
            label: '证券从业人员',
          },
          {
            value: '个体工商户',
            label: '个体工商户',
          },
          {
            value: '学生',
            label: '学生',
          },
          {
            value: '无业',
            label: '无业',
          },
          {
            value: '其他',
            label: '其他',
          },
        ],
        sincerityRecord: [
          '无',
          '中国人民银行征信机构',
          '最高人民法院失信被执行人名单',
          '工商行政管理机构',
          '税务管理机构',
          '监管机构、自律组织',
          '投资者在证券经营机构从事投资活动时产生的违约等失信行为记录',
          '慈善维权等不当行为信息',
        ],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['loginInfo']),
    userPhone() {
      const str = this.loginInfo?.phone ?? '';
      return replaceToHidden(str, 3, 4, '*');
    },
  },
  mounted() {
    this.importPca();
  },
  methods: {
    ...mapActions('user', ['updateUserInfoKyc']),
    /**
     * @description 提交验证
     */
    submit() {
      this.$refs.form.validate(async (res, error) => {
        if (res) {
          let data;
          if (this.form.identityType === 'IDENTITY_CARD') {
            data = await this.$axios(
              checkMobileMetaV2({
                identifyNum: this.form.idNumber,
                userName: this.form.realName,
              })
            );
          } else if (this.form.identityType === 'RESIDENCE_PERMIT') {
            data = await this.$axios(
              checkMobileMetaHK({
                identifyNum: this.form.idNumber,
                userName: this.form.realName,
              })
            );
          } else if (this.form.identityType === 'OTHER') {
            data = {
              statusCode: 200,
            };
          }
          if (data.statusCode === 200) {
            const {
              realName,
              identityType,
              otherIdentityType,
              idNumber,
              highestEducation,
              career,
              location,
              address,
              telephone,
              postcode,
              sincerityRecord,
              company,
              position,
              email,
            } = this.form;
            const query = {
              realName,
              identityType,
              otherIdentityType,
              idNumber: idNumber.slice(-4),
              phone: this.loginInfo?.phone ?? '',
              highestEducation,
              career,
              location: location.join('/'),
              address,
              telephone,
              postcode,
              sincerityRecord,
              company,
              position,
              email,
            };
            const res = await this.$axios(realNameAuthentication(query));
            if (res.statusCode === 200) {
              if (identityType !== 'OTHER') {
                this.updateUserInfoKyc({
                  certification: true,
                });
              }
              this.$emit('submitSuccess', identityType);
            } else {
              this.messageData = {
                show: true,
                content: res.message,
              };
            }
          } else {
            this.messageData = {
              show: true,
              content: data.message,
            };
          }
        } else {
          const resArr = [
            'realName',
            'code',
            'highestEducation',
            'career',
            'location',
            'address',
          ];
          for (const prop of resArr) {
            if (error[prop]) {
              const el = this.$refs[`form-${prop}`];
              if (el && el.$el) {
                this.$refs['form-scrollbar'].wrap.scrollTop = el.$el.offsetTop;
              }
              return false;
            }
          }
        }
      });
    },
    /**
     * @description 获取地区级联
     */
    async importPca() {
      const data = await fetch(
        'https://cdn.gelonghui.com/static/mobile/json/area.json',
        {
          method: 'GET',
          headers: {
            Accept: 'application/json',
          },
        }
      );
      const arr = await data.json();
      this.pcaTextArr = arr;
    },
  },
};
